import { WHATSAPP_NUMBER } from "@/lib/config";
import { motion } from "framer-motion";
import { useLang } from "@/lib/LanguageContext";

export default function WhatsAppFab() {
    const { t } = useLang();
    const open = () => {
        const msg = encodeURIComponent(t("wa_message"));
        window.open(
            `https://wa.me/${WHATSAPP_NUMBER}?text=${msg}`,
            "_blank",
            "noopener,noreferrer",
        );
    };

    return (
        <motion.button
            initial={{ opacity: 0, scale: 0.7 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 1.5 }}
            onClick={open}
            aria-label="Chat on WhatsApp"
            className="fixed bottom-5 right-5 z-50 h-14 w-14 md:h-16 md:w-16 rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_rgba(37,211,102,0.35)] flex items-center justify-center hover:scale-105 transition-transform"
            data-testid="whatsapp-fab"
        >
            <svg
                viewBox="0 0 32 32"
                className="h-7 w-7 md:h-8 md:w-8 fill-current"
                aria-hidden="true"
            >
                <path d="M19.11 17.28c-.29-.15-1.72-.85-1.98-.95-.27-.1-.46-.15-.66.15-.19.29-.75.94-.92 1.14-.17.19-.34.22-.63.07-.29-.15-1.24-.46-2.36-1.46-.87-.78-1.46-1.75-1.63-2.04-.17-.29-.02-.45.13-.6.13-.13.29-.34.44-.51.15-.17.19-.29.29-.48.1-.19.05-.36-.02-.51-.07-.15-.66-1.58-.9-2.16-.24-.57-.48-.49-.66-.5-.17-.01-.36-.01-.55-.01s-.51.07-.78.36c-.27.29-1.02 1-1.02 2.43s1.05 2.82 1.2 3.02c.15.19 2.07 3.16 5.02 4.43.7.3 1.25.49 1.68.63.71.22 1.35.19 1.86.11.57-.08 1.72-.7 1.96-1.38.24-.68.24-1.26.17-1.38-.07-.12-.26-.19-.55-.34zM16.03 3.2C9.03 3.2 3.35 8.88 3.35 15.88c0 2.25.59 4.42 1.71 6.32L3 29.3l7.31-1.91c1.83.99 3.89 1.52 5.98 1.52h.01c7 0 12.68-5.68 12.68-12.68 0-3.39-1.32-6.57-3.71-8.97-2.4-2.4-5.58-3.72-8.97-3.72zm7.4 20.1c-.32.9-1.85 1.71-2.6 1.83-.68.11-1.55.16-2.5-.16-.58-.19-1.32-.44-2.27-.87-3.99-1.72-6.6-5.74-6.8-6-.19-.26-1.6-2.13-1.6-4.06 0-1.94 1-2.89 1.36-3.29.36-.4.79-.5 1.05-.5.26 0 .53 0 .76.01.24.01.57-.09.9.68.32.79 1.1 2.73 1.2 2.93.1.19.16.42.03.68-.13.26-.19.42-.38.65-.19.22-.4.5-.57.67-.19.19-.39.4-.17.78.22.38 1 1.65 2.14 2.67 1.47 1.31 2.71 1.72 3.09 1.91.38.19.6.16.83-.1.22-.26.95-1.11 1.2-1.5.24-.38.49-.32.83-.19.34.13 2.16 1.02 2.53 1.2.38.19.63.29.72.45.09.16.09.94-.23 1.84z" />
            </svg>
            <span className="sr-only">WhatsApp</span>
        </motion.button>
    );
}
